/**
 * @generated SignedSource<<a80837b1990e266de53002e7173b07a6>>
 * @relayHash 21ad9d736d54d68dbeeaf76be0ef1ebd
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21ad9d736d54d68dbeeaf76be0ef1ebd

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteAttestationGuardianInput = {
  id: string;
};
export type useChDeleteLegalGuardianAttestationMutation$variables = {
  input: Ch_deleteAttestationGuardianInput;
};
export type useChDeleteLegalGuardianAttestationMutation$data = {
  readonly ch_deleteAttestationGuardian: {
    readonly ch_AttestationGuardian: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteLegalGuardianAttestationMutation = {
  response: useChDeleteLegalGuardianAttestationMutation$data;
  variables: useChDeleteLegalGuardianAttestationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteLegalGuardianAttestationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteAttestationGuardianPayload",
        "kind": "LinkedField",
        "name": "ch_deleteAttestationGuardian",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_AttestationGuardian",
            "kind": "LinkedField",
            "name": "ch_AttestationGuardian",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteLegalGuardianAttestationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteAttestationGuardianPayload",
        "kind": "LinkedField",
        "name": "ch_deleteAttestationGuardian",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_AttestationGuardian",
            "kind": "LinkedField",
            "name": "ch_AttestationGuardian",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "21ad9d736d54d68dbeeaf76be0ef1ebd",
    "metadata": {},
    "name": "useChDeleteLegalGuardianAttestationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e27f76c06d8ebba7da5e77cf8459ad68";

export default node;
